// ./src/styles/themes/light.ts

import { ConfigStyles } from '@config/index';

// DEFINIÇÃO DE ESTILOS LIGHT
const { rebox } = ConfigStyles;
const light: typeof rebox = {
  ...rebox,
};

export default light;
